import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Paths } from "./../../constants/UrlConstants";
import contentify from "../../content/Contentify";
import Store from "./../../content/Store";
import style from "../../assets/css/modules/cover/cover.css";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import HelpSection from "../shared/HelpSection";
import PromoContainer from "../shared/containers/PromoContainer";
import PromoImageCard from "../../components/shared/PromoImageCard";

export const mapStateToProps = state => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    IsLargeCorp: selectedPolicy && selectedPolicy.IsLargeCorporate,
    IsSME: selectedPolicy && selectedPolicy.IsSME,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    HideCoverDetails: selectedPolicy && selectedPolicy.IsFormat2
  };
};

export class MakeChangesToCover extends Component {
  static content = {
    ...Store.Cover,
    ...Store.MakeChangesToCover,
    ...Store.Home.Cards
  };
  render() {
    return this.props.IsLargeCorp ||
      this.props.IsSME ||
      this.props.IsSaga ||
      this.props.IsInternational ? (
      <Redirect to={Paths.NotFound} />
    ) : (
      <React.Fragment>
        <ShadowedContainer>
          <div className="row">
            <div className="col-12">
              <div className={style.articleDescription}>
                <Article
                  header={this.props.content.MakeChangesHeader}
                  body={this.props.content.MakeChangesDescription}
                />
              </div>
            </div>
          </div>
          <hr />
          <HelpSection
            HeadingLinkText={this.props.content.HelpSection.HeadingLinkText}
            HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
            MoreHelpLinkText={this.props.content.HelpSection.MoreHelpLinkText}
            MoreHelpLinkTo={this.props.content.HelpSection.MoreHelpLinkTo}
            HelpSet={this.props.content.HelpSection.HelpSet}
          />
        </ShadowedContainer>
        <PromoContainer>
          <PromoImageCard
            ImgSrc={this.props.content.AskMedExpert.IconSrc}
            ImgSrcMobile={this.props.content.AskMedExpert.IconSrcMobile}
            Heading={this.props.content.AskMedExpert.Heading}
            Description={this.props.content.AskMedExpert.Description}
            LinkText={this.props.content.AskMedExpert.LinkText}
            LinkTo={this.props.content.AskMedExpert.LinkTo}
            LeftImage
          />
        </PromoContainer>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(contentify(MakeChangesToCover));
